import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MultiShipmentExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { PolarisChoice } from '@app/sharedModule/components/polaris/components/choice-list/s-polaris-choice-list.component';

@Component({
  selector: 'multi-shipment-is-multi-picker-preview',
  templateUrl: './is-multi-picker-preview.component.html',
  styleUrls: ['./is-multi-picker-preview.component.scss'],
  standalone: false,
})
export class IsMultiPickerPreviewComponent implements OnChanges {
  @Input() shippingToggle: MultiShipmentExtension.ShippingToggle;
  @Input() selection: MultiShipmentExtension.ShippingMode = 'single';

  @Output() selectionChange = new EventEmitter<MultiShipmentExtension.ShippingMode>();

  choices: PolarisChoice[] = [];

  ngOnChanges(): void {
    const single = this.shippingToggle?.singleAddress;
    const multi = this.shippingToggle?.multiAddress;
    this.choices = [
      { title: single?.title ?? '', description: single?.description ?? '', selected: this.selection === 'single' },
      { title: multi?.title ?? '', description: multi?.description ?? '', selected: this.selection === 'multi' },
    ];
  }

  onChoiceSelected(choiceIndex: number): void {
    this.selectionChange.emit(choiceIndex === 0 ? 'single' : 'multi');
  }
}
